import {bookingReturnTo} from "../consultation-wizard/booking-entry";

export function authBookingReturn(search: string): string | null {
  const values = new URLSearchParams(search).getAll("return_to");
  return values.length === 1 ? bookingReturnTo(values[0]!) : null;
}

export function authDestination(search: string): string {
  return authBookingReturn(search) ?? "/app/";
}

export function authTriggerBookingReturn(trigger: HTMLElement): string | null {
  if (!(trigger instanceof HTMLAnchorElement)) return null;
  const url = new URL(trigger.href, window.location.href);
  if (url.origin !== window.location.origin || (url.pathname !== "/signin" && url.pathname !== "/signup")) return null;
  return authBookingReturn(url.search);
}
